import React, { useState, useEffect, useRef } from 'react';
import PersonalInfo from '../components/Form2Print/PersonalInfo';
import '../styles/styles.css';
import '../styles/Form2Print.css';
import logo from '../uploads/logo.png';
import { useNavigate } from 'react-router-dom';
import EducationInfo from '../components/Form2Print/EducationInfo';
import EmploymentInfo from '../components/Form2Print/EmploymentInfo';
import RelativesInfo from '../components/Form2Print/RelativesInfo';
import AdditionalInfo from '../components/Form2Print/AdditionalInfo';
import Disclaimer from '../components/Form2Print/Disclaimer';
import { Helmet } from 'react-helmet';
import { message, Spin, FloatButton } from 'antd';
import { FileWordOutlined, FilePdfOutlined, PrinterOutlined } from '@ant-design/icons';
import { API_URL, API_username, API_password } from '../utils/api';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import Navbar from '../components/Form2Print/NavBar';

const Form2Print = () => {
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		getinfo();
	}, []);
	const navigate = useNavigate();
	const targetRef = useRef();

	const [formData, setFormData] = useState({
		Name: '',
		BirthDate: '',
		BirthPlace: {
			SpecialBirthPlace: 0,
			City: "",
			District: "",
			Region: "",
			Country: {
				Name: "",
				UID: ""
			}
		},
		Nationality: {
			Name: "",
			UID: ""
		},
		Citizenship: {
			Name: "",
			UID: ""
		},
		Passport: {
			type: {
				Name: "",
				UID: ""
			},
			DocSeries: '',
			DocNumber: '',
			DocIssued: '',
			DocDateIssued: '',
			departmentCode: '',
			DocValid: '',
			DocInfoValid: ''			
		},
		MaritalStatus: {
			Name: "",
			UID: ""
		},
		EmailWork: '',
		EmailPersonal: '',
		INN: '',
		INPS: '',
		Sex: {
			Name: "",
			UID: ""
		},
		Photo: null,
		MobilePhoneWork: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		HomePhoneNumber: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		MobilePhonePersonal: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		WorkPhoneNumber: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
	});

	const [educationData, setEducationData] = useState([
		{
			Start: '',
			End: '',
			EducationType: {
				Name: '',
				UID: ''
			},
			EducationKind: {
				Name: '',
				UID: ''
			},
			Institution: {
				Name: '',
				UID: ''
			},
			Faculty: '',
			Speciality: {
				Name: '',
				UID: ''
			},
			DocTypeEducation: {
				Name: '',
				UID: ''
			},
			DocSeries: '',
			DocNumber: '',
			DocDateIssued: ''
		}
	]);

	const [languageData, setLanguageData] = useState([
		{
			Language: {
				Name: '',
				UID: ''
			},
			LanguageDegree: {
				Name: '',
				UID: ''
			}
		}
	]);

	const [computerSkillsData, setComputerSkillsData] = useState([
		{
			Software: {
				Name: '',
				UID: ''
			},
			SoftwareLevel: {
				Name: '',
				UID: ''
			}
		}
	]);

	const [employmentData, setEmploymentData] = useState([
		{
			EmploymentDate: '',
			DismissalDate: '',
			Organization: '',
			Departament: '',
			Position: '',
			Address: '',
			Duties: '',
			ActivityProfile: '',
			Country: {
				Name: '',
				UID: ''
			},
			City: '',
			EmploymentType: {
				Name: '',
				UID: ''
			}
		}
	]);

	const [relativesData, setRelativesData] = useState([
		{
			RelationshipDegree: {
				Name: '',
				UID: ''
			},
			Name: '',
			BirthDate: '',
			BirthPlace_Country: {
				Name: '',
				UID: ''
			},
			Position: '',
			ResidencePlace: '',
			WorkPlace: '',
			Dependent: '',
			IsDisabled: ''
		}
	]);

	const [RegistrationAddress, setRegistrationAddress] = useState({
		AddressType: "",
		Country: {
			Name: "",
			UID: ""
		},
		City: {
			Subject: "",
			Area: "",
			MunicipalDistrict: "",
			City: "",
			Village: "",
			IntracityDistrict: "",
			PopulationPoint: "",
			Territory: "",
		},
		Street: "",
		HouseType: "",
		TypeBuilding: "",
		TypePremises: "",
		House: "",
		Building: "",
		Premises: "",
		Index: "",
		ViewAddresses: ""
	});

	const [ResidenceAddress, setResidentialAddress] = useState({
		AddressType: "",
		Country: {
			Name: "",
			UID: ""
		},
		City: {
			Subject: "",
			Area: "",
			MunicipalDistrict: "",
			City: "",
			Village: "",
			IntracityDistrict: "",
			PopulationPoint: "",
			Territory: "",
		},
		Street: "",
		HouseType: "",
		TypeBuilding: "",
		TypePremises: "",
		House: "",
		Building: "",
		Premises: "",
		Index: "",
		ViewAddresses: ""
	});
	const [ShiftMode, setShiftWorkReady] = useState('Да');
	const [Prosecution, setLegalIssues] = useState('Да');



	const handleFormSubmit = (event) => {
		// Обработка отправки формы
		event.preventDefault();
		// Ваша логика обработки данных формы
		console.log(formData);
	};

	const handleCreateDocxFile = () => {
		
	};

	const printPDFOptions = {
		filename: `Форма_2_${formData.Name.replace(' ', '_')}.pdf`,
		method: 'save',
		resolution: Resolution.MEDIUM,
		page: {
		   margin: {top: 10, right: 0, bottom: 10, left: 0},
		   format: 'A4',
		   orientation: 'portrait',
		},
		canvas: {
		   mimeType: 'image/png',
		   qualityRatio: 1
		},
		overrides: {
		   pdf: {
			  compress: true
		   },
		   canvas: {
			  useCORS: true
		   }
		},
	 };

	const PdfDownloadComponent = () => {
		generatePDF(targetRef, printPDFOptions);
	}

	const getinfo = () => {
		let apiUrl = `${API_URL}/lk?method=getinfo&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, авторизуйтесь заново!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				setFormData(prevState => {
					const updatedFormData = { ...prevState };
					processFormData(data, updatedFormData);
					return updatedFormData;
				});
				setEducationData(data.Education);
				setLanguageData(data.Languages);
				setComputerSkillsData(data.ComputerSkills);
				setEmploymentData(data.LaborActivity);
				setRelativesData(data.Family);
				setRegistrationAddress(data.RegistrationAddress);
				setResidentialAddress(data.ResidenceAddress);
				setShiftWorkReady(data.ShiftMode);
				setLegalIssues(data.Prosecution);
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => {
			setLoading(false);
		});
	};

	const formatDate = (date) => {
		const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
	};

	const processFormData = (data, formData) => {
		for (const key in data) {
			if (formData.hasOwnProperty(key)) {
				// Если значение является объектом, вызываем processFormData рекурсивно
				if (typeof data[key] === 'object' && data[key] !== null) {
					formData[key] = processFormData(data[key], formData[key] || {});
				} else {
					// Обработка даты рождения и других полей, если необходимо
					if (key === "BirthDate" || key === "DocDateIssued" || key === "DocValid" || key === "DocInfoValid" || key === "Start" || key === "End" || key === "DocDateIssued") {
						formData[key] = formatDate(data[key]);
					} else {
						// Присваиваем другие значения как есть
						formData[key] = data[key];
					}
				}
			}
		}
		return formData;
	};

	return (
		<>
		<div className='dashboard'>
			<Navbar />
			<div className='dashboard-content'>
				{loading && (<div className='loader-container'>
					<Spin size="large"/>
				</div>)}
				<div className="container" id='form2print' ref={targetRef}>
					<Helmet>
						<title>Форма 2</title>
					</Helmet>
					<div className='toPrint'>
						<img src={logo} style={{ height: '11.4mm' }} />
						<i style={{ float: 'right', margin: '15px 35px 0 0', fontSize: '12pt' }}>Форма №2</i>
					</div>
					<PersonalInfo className='toPrint' formData={formData} />
					<EducationInfo className='toPrint' educationData={educationData} languageData={languageData} computerSkillsData={computerSkillsData} />
					<EmploymentInfo className='toPrint' employmentData={employmentData} />
					<RelativesInfo className='toPrint' relativesData={relativesData} registrationAddress={RegistrationAddress} residentialAddress={ResidenceAddress} />
					<AdditionalInfo className='toPrint' shiftWorkReady={ShiftMode} legalIssues={Prosecution} />
					<Disclaimer className='toPrint' />
				</div>
				<FloatButton.Group
					trigger="click"
					type="primary"
					style={{ right: 24 }}
					icon={<PrinterOutlined />}
					>
					<FloatButton onClick={PdfDownloadComponent} icon={<FilePdfOutlined />} />
					<FloatButton onClick={handleCreateDocxFile} icon={<FileWordOutlined />} />
				</FloatButton.Group>
			</div>
		</div>
		</>
	);
};

export default Form2Print;
